var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHubspotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "8 4 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hubspot",
    filter: "url(#filter0_dd_2704_49797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 42",
    x: 8,
    y: 4,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FF641D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.8571 34.9001C53.0691 33.5443 51.9606 32.4574 50.5748 31.6391C49.5392 31.0362 48.4654 30.6536 47.2553 30.4892V26.1813C48.4654 25.6675 49.2164 24.5302 49.2164 23.2034C49.2164 21.3951 47.7662 19.9296 45.9592 19.9296C44.1509 19.9296 42.6753 21.3951 42.6753 23.2034C42.6753 24.5302 43.3829 25.6675 44.593 26.1813V30.4912C43.625 30.6311 42.6211 30.9329 41.7043 31.3966C39.8318 29.9745 33.6917 25.309 30.0999 22.5841C30.1851 22.277 30.2506 21.9604 30.2506 21.6264C30.2506 19.6235 28.6286 18 26.6249 18C24.6212 18 22.9999 19.6235 22.9999 21.6264C22.9999 23.6292 24.6229 25.2531 26.6266 25.2531C27.3101 25.2531 27.9422 25.0532 28.4878 24.7246L29.2458 25.2996L39.6614 32.8042C39.1108 33.3098 38.5979 33.8848 38.1877 34.53C37.3564 35.8454 36.8484 37.2927 36.8484 38.8714V39.2008C36.8484 40.309 37.0589 41.3553 37.4176 42.3381C37.7334 43.1963 38.1952 43.9766 38.7671 44.6821L35.3103 48.1473C34.8094 47.9609 34.2653 47.9226 33.7431 48.0371C33.221 48.1516 32.7429 48.414 32.3659 48.793C32.1049 49.0528 31.898 49.3617 31.7573 49.7019C31.6165 50.0422 31.5447 50.407 31.5459 50.7752C31.5462 51.5238 31.8378 52.2273 32.3674 52.7566C32.6269 53.0178 32.9357 53.2249 33.2759 53.3659C33.616 53.5069 33.9808 53.579 34.349 53.578C34.7174 53.579 35.0822 53.5069 35.4225 53.3659C35.7628 53.2249 36.0717 53.0178 36.3314 52.7566C36.5923 52.4969 36.7991 52.1881 36.9399 51.848C37.0807 51.5079 37.1528 51.1433 37.1519 50.7752C37.1519 50.4855 37.1071 50.2028 37.0229 49.9342L40.5958 46.3607C41.0857 46.6991 41.6147 46.9839 42.1835 47.2296C43.3053 47.7146 44.5434 48.0101 45.8985 48.0101H46.1468C47.6449 48.0101 49.0581 47.6582 50.3865 46.9384C51.7864 46.1778 52.882 45.1376 53.7097 43.8096C54.5418 42.478 54.9999 41.0067 54.9999 39.3881V39.3073C54.9999 37.715 54.6313 36.246 53.8571 34.9001ZM49.4915 42.3962C48.5218 43.4739 47.407 44.1378 46.1468 44.1378H45.9392C45.2194 44.1378 44.5154 43.9388 43.8261 43.577C43.0492 43.1786 42.4587 42.6104 41.9753 41.8909C41.4758 41.1846 41.2048 40.4136 41.2048 39.596V39.3477C41.2048 38.5439 41.3589 37.7818 41.7476 37.062C42.1632 36.2752 42.7244 35.6634 43.4708 35.1769C44.2036 34.6939 44.9863 34.4569 45.8581 34.4569H45.9392C46.7296 34.4569 47.4779 34.6128 48.1842 34.9741C48.9037 35.3594 49.4915 35.8858 49.9473 36.5782C50.3899 37.2709 50.6532 38.018 50.738 38.8319C50.7513 39.0011 50.758 39.1744 50.758 39.34C50.758 40.4445 50.336 41.4676 49.4915 42.3962Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2704_49797",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_49797"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2704_49797",
    result: "effect2_dropShadow_2704_49797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2704_49797",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotIcon);
export default __webpack_public_path__ + "static/media/hubspot-icon.63859521815030f25c906c32d8b0bcec.svg";
export { ForwardRef as ReactComponent };